
import Vue from 'vue'
import axios from 'axios'
import { DateTime } from 'luxon'
import { Component } from 'vue-property-decorator'
import { downloadFile } from '../../global/functions/util'

@Component
export default class AssignmentReportModal extends Vue {
  show = false

  dates: string[] = []

  open() {
    this.show = true
  }

  close() {
    this.dates = []
    this.show = false
  }

  download() {
    const dates = this.dates.map(date => DateTime.fromISO(date))
    dates.sort()
    const url = new URL(`${axios.defaults.baseURL}/jobs/assignment-report`)
    url.searchParams.append('from', dates[0].toString())
    url.searchParams.append('to', dates[1].toString())
    downloadFile(url.href)
    this.close()
  }
}
